module.exports = __webpack_public_path__ + "img/arrow-right.cc7e7e1e.svg";